import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { adminAPI } from '../../utils/api';
import { Card } from '../../components/ui/card';
import { Users, FileCheck, TrendingUp, ArrowDownLeft, ArrowUpRight, MessageSquare } from 'lucide-react';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await adminAPI.getDashboardStats();
      setStats(response.data);
    } catch (error) {
      toast.error('Failed to load stats');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="flex items-center justify-center min-h-[60vh]"><div className="loading-spinner"></div></div>;

  const statCards = [
    { label: 'Total Users', value: stats?.total_users, icon: Users, color: 'bg-blue-500/10 text-blue-400' },
    { label: 'Active Users', value: stats?.active_users, icon: Users, color: 'bg-green-500/10 text-green-400' },
    { label: 'Pending KYC', value: stats?.pending_kyc, icon: FileCheck, color: 'bg-yellow-500/10 text-yellow-400' },
    { label: 'Pending Trades', value: stats?.pending_trades, icon: TrendingUp, color: 'bg-purple-500/10 text-purple-400' },
    { label: 'Pending Deposits', value: stats?.pending_deposits, icon: ArrowDownLeft, color: 'bg-emerald-500/10 text-emerald-400' },
    { label: 'Pending Withdrawals', value: stats?.pending_withdrawals, icon: ArrowUpRight, color: 'bg-red-500/10 text-red-400' },
    { label: 'Open Tickets', value: stats?.open_tickets, icon: MessageSquare, color: 'bg-orange-500/10 text-orange-400' },
  ];

  return (
    <div className="space-y-8 animate-fadeIn" data-testid="admin-dashboard">
      <div>
        <h1 className="text-2xl sm:text-4xl font-bold text-foreground mb-2">Admin Dashboard</h1>
        <p className="text-muted-foreground">Overview of platform activity</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((stat, idx) => (
          <Card key={idx} className="stat-card" data-testid={`stat-${stat.label.toLowerCase().replace(' ', '-')}`}>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-muted-foreground text-sm mb-1">{stat.label}</p>
                <h3 className="text-3xl font-bold text-foreground">{stat.value || 0}</h3>
              </div>
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${stat.color}`}>
                <stat.icon className="w-6 h-6" />
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
